import { DateUtil } from '@src/packages/utils/dates';
import {
  ATTENDANCE_EVENT_ACTOR_ROLE,
  ATTENDANCE_EVENT_TYPE,
} from '@src/packages/workJourney/constants';
import AttendanceEventService from '@src/services/AttendanceEventService';
import PrepareAttendanceSessionService from '@src/services/PrepareAttendanceSessionService';

type ShiftStartAttendanceEventService = Pick<AttendanceEventService, 'createAttendanceEvent'>;
type ShiftStartPrepareService = Pick<PrepareAttendanceSessionService, 'prepareOfficialRecord'>;

export type CreateShiftStartAttendanceEventParams = {
  organizationId: string;
  actorId: string;
  employeeId: string;
  markedAt: Date;
  attendanceRecordId: string | null;
  attendanceEventService: ShiftStartAttendanceEventService;
  prepareAttendanceSessionService: ShiftStartPrepareService;
};

export const createShiftStartAttendanceEvent = async ({
  organizationId,
  actorId,
  employeeId,
  markedAt,
  attendanceRecordId,
  attendanceEventService,
  prepareAttendanceSessionService,
}: CreateShiftStartAttendanceEventParams): Promise<string> => {
  let recordId = attendanceRecordId;
  if (!recordId) {
    const prepared = await prepareAttendanceSessionService.prepareOfficialRecord({
      organizationId,
      employeeId,
      shiftStartAtDevice: markedAt.toISOString(),
    });
    recordId = prepared.recordId;
  }

  await attendanceEventService.createAttendanceEvent({
    organizationId,
    attendanceRecordId: recordId,
    employeeId,
    attendanceType: ATTENDANCE_EVENT_TYPE.SHIFT_START,
    actorId,
    actorRole: ATTENDANCE_EVENT_ACTOR_ROLE.SUPERVISOR,
    timeZone: DateUtil.getDefaultTimeZone(),
    createdAtDevice: markedAt.getTime(),
  });

  return recordId;
};
